import { EyeIcon, PencilSquareIcon, PrinterIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useApplicationModals } from "app/common/hooks";
import {
  useCollector,
  usePaginatedCollector,
} from "app/integration/common/hooks";
import {
  BadgeButton,
  IconButton,
  ServerSidePaginationButtons,
} from "app/components/atoms/button";
import { SearchInput } from "app/components/atoms/input";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import ImageWithPreview from "app/components/molecules/imageWithPreview";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { productVariant } from "app/integration/api";
import { Badge } from "app/components/atoms/badge";

const breadcrumbItems = [
  { label: "Stock Opname", href: "#" },
];

function StockOpname() {
  const { openModal, setPayloads } = useApplicationModals();
  const [params, setParams] = useState({
    search: "",
    stock_opname_search: "",
    status: null,
    customer_id: null,
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    collect(params);
  }, [params]);

  const [
    stockOpnames,
    setStockOpnames,
    stockOpnamesLoader,
    collect,
    stockOpnamePaginationProps,
  ] = usePaginatedCollector({ modelName: "stockOpname", params: params });

  const [productVariants] = useCollector({ modelName: "productVariant" });

  return (
    <MainLayout
      activeSidebarNavigation="warehouse"
      activeSidebarChild="stock_opname"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Stock Opname"
      headingButtons={[
        {
          label: "Tambah",
          type: "menuButton",
          href: "/stock-opname/create",
          items: [
            {
              label: "Stock Opname Scan Barcode",
              type: "routerButton",
              href: "/stock-opname/create",
            },
            {
              label: "Stock Opname Manual",
              onClick: () => openModal("stockOpname.create"),
            },
          ],
        },
      ]}
    >
      <AppModals
        items={["stockOpname.create"]}
        onSuccess={{
          "stockOpname.create": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              <SearchInput testId="stock-opname-search-input"
                placeholder="Cari Stock Opname"
                type="text"
                value={params.stock_opname_search}
                // onChange={handleQueryChange}
                onChange={(e) =>
                  setParams({ ...params, stock_opname_search: e.target.value })
                }
              />
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Produk</Table.Heading>
              <Table.Heading>Produk Variant</Table.Heading>
              <Table.Heading>Stok Fisik</Table.Heading>
              <Table.Heading>Stok Sistem</Table.Heading>
              <Table.Heading>Selisih</Table.Heading>
              <Table.Heading>Tanggal</Table.Heading>
              <Table.Heading>Status</Table.Heading>
              <Table.Heading>Deskripsi</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {stockOpnames?.map((stockOpname, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{productVariants?.find((item) => item.id === stockOpname?.product_variant_id)?.product_detail?.name}</Table.Cell>
                <Table.Cell>{productVariants?.find((item) => item.id === stockOpname?.product_variant_id)?.color?.name}, {productVariants?.find((item) => item.id === stockOpname?.product_variant_id)?.size?.name}</Table.Cell>
                <Table.Cell>
                  {parseInt(stockOpname?.physical_stock)}
                </Table.Cell>
                <Table.Cell>
                  {parseInt(stockOpname?.system_stock)}
                </Table.Cell>
                <Table.Cell>
                  {parseInt(stockOpname?.difference)}
                </Table.Cell>
                <Table.Cell>
                  <Typography.Date date={stockOpname?.opname_date} format="dd MMMM yyyy hh:mm:ss" />
                </Table.Cell>
                <Table.Cell>
                  <Badge color={stockOpname?.status === "pending" ? "yellow" : stockOpname?.status === "approved" ? "green" : "red"}>{stockOpname?.status}</Badge>
                </Table.Cell>
                <Table.Cell>
                  {stockOpname?.description}
                </Table.Cell>
                <Table.Cell>
                  <div className="flex gap-1 items-center">
                    <IconButton testId="stock-opname-eye-button"
                      icon={EyeIcon}
                      href={`/stock-opname/${stockOpname.id}`}
                    />
                    {/* <IconButton testId="stock-opname-pencil-square-button"
                      icon={PencilSquareIcon}
                      onClick={(e) => {
                        setPayloads("stockOpname.update", {
                          id: stockOpname.id,
                        });
                        openModal("stockOpname.update");
                      }}
                    />
                    <IconButton testId="stock-opname-trash-button"
                      icon={TrashIcon}
                      onClick={(e) => {
                        setPayloads("stockOpname.delete", {
                          id: stockOpname.id,
                        });
                        openModal("stockOpname.delete");
                      }}
                    /> */}
                  </div>
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
        <Table.PaginationWrapper>
          <ServerSidePaginationButtons
            paginationProps={stockOpnamePaginationProps}
            params={params}
            setParams={setParams}
          />
        </Table.PaginationWrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default StockOpname;
